import { useGlobalSearchParams, usePathname } from 'expo-router';

/** NOTE!
 * these redirects can be removed once:
 * - all links are eliminated referencing them (check braze, branch, emails, etc.)
 * - nearly 100% of users are on 7.47.0+
 */
const legacyRedirects: [RegExp, string][] = [
  // simple /foo/bar -> /baz
  [/^\/signup$/, '/signin'],
  [/^\/rewards\/details$/, '/rewards'],
  [/^\/store-locator\/address$/, '/store-locator/delivery-address'],
  [/^\/account\/payment\/add-card$/, '/payment/add-card'],
  [/^\/account\/payment\/add-gift-card$/, '/payment/add-gift-card'],
  [/^\/account\/payment\/transfer-gift-card$/, '/payment/transfer-gift-card'],

  // menu routes
  [/^\/menu\/section-(.*)$/, '/menu/section'], // /menu/section-ID -> /menu/section/ID
  [/^\/menu\/item-(.*)$/, '/menu/item'], // /menu/item-ID -> /menu/section/ID
  [/^\/menu\/picker-(.*)$/, '/menu/picker'], // /menu/picker-ID -> /menu/section/ID OR /menu/picker-picker_4735 -> /menu/picker/picker_4735 etc.
  [/^\/menu\/combo-(.*)$/, '/menu/combo'], // /menu/combo-ID -> /menu/section/ID

  // complex /foo/bar* -> /baz* ETC
  [/^\/rewards\/offers(?:\/([^/]+))?$/, '/offers'], // /rewards/offers* -> /offers*
  [/^\/rewards\/list(?:\/([^/]+))?$/, '/rewards'], // /rewards/list* -> /rewards*
  [/^\/rewards\/offers-group(?:\/([^/]+))?$/, '/rewards/group'], // /rewards/offers-group/* -> /rewards/group/*
];

// strip these expo-router internal params to avoid issues on redirects
const INTERNAL_PARAMS = ['initial', 'path', 'pop', 'state', 'not-found'];

export const useMaybeGetLegacyRedirect = (stripParams: string[] = []) => {
  const pathname = usePathname();
  const params = useGlobalSearchParams();

  let query = '';
  if (Object.keys(params).length > 0) {
    const urlParams = new URLSearchParams(params as Record<string, string>);
    INTERNAL_PARAMS.concat(stripParams).forEach(p => {
      urlParams.delete(p);
    });
    query = urlParams.toString();
  }

  for (const [rgx, redirect] of legacyRedirects) {
    const match = rgx.exec(pathname);
    if (match) {
      let redirectBuilder = match?.[1] ? `${redirect}/${match?.[1]}` : redirect;

      if (query) {
        redirectBuilder += `?${query}`;
      }

      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('Legacy redirect', {
          from: pathname + (query ? `?${query}` : ''),
          to: redirectBuilder,
        });
      }
      return redirectBuilder;
    }
  }
  return null;
};
